module.exports = __webpack_public_path__ + "static/media/dollar-circle-white.44d6f362.svg";